<template>
  <div>
    <v-row no-gutters v-if="loading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <v-card flat>
      <v-card-title class="pa-0 pb-2">{{ $t('message.layout.projects') }}</v-card-title>
      <v-divider class="mb-3"></v-divider>
      <v-card-text class="pa-0">
        <template v-for="project in listOfProjects">
          <v-card :key="project.id" class="mb-5">
            <v-row class="mx-0 px-3 pt-3">
              <v-flex xs6 sm4 md3 lg3 class="mb-2"><strong>{{ $t('message.common.number') }}: </strong>{{ project.number }}</v-flex>
              <v-flex xs6 sm4 md3 lg3 class="mb-2"><strong>{{ $t('message.common.name') }}: </strong>{{ project.name }}</v-flex>
              <v-flex xs6 sm4 md3 lg3 class="mb-2"><strong>{{ $t('message.common.responsible') }}: </strong>{{ project.responsible }}</v-flex>
              <v-flex xs6 sm4 md3 lg3 class="mb-2"><strong>{{ $t('message.common.endDate') }}: </strong>{{ project.enddate }}</v-flex>
              <v-flex xs6 sm4 md3 lg3 class="mb-2"><strong>{{ $t('message.common.cost') }}: </strong>{{ project.cost }}</v-flex>
              <v-flex xs6 sm4 md3 lg3 class="mb-2"><strong>{{ $t('message.common.estimatedHours') }}: </strong>{{ project.estimated_hrs }}</v-flex>
              <v-flex xs6 sm4 md3 lg3 class="mb-2"><strong>{{ $t('message.common.receivedPayment') }}: </strong>{{ project.received_payment }}</v-flex>
            </v-row>
            <v-card-text class=" py-0 px-3 h6 font-weight-bold">{{ $t('message.common.hoursDetails') }}:</v-card-text>
            <!-- <v-divider class="mx-2"></v-divider> -->
            <v-row class="mx-0 px-3 py-0">
              <v-flex xs6 sm4 md3 lg3 class="mb-2"><strong>{{ $t('message.timer.notDelivered') }}: </strong>{{ 2 | replaceDotWithComma }}</v-flex>
              <v-flex xs6 sm4 md3 lg3 class="mb-2"><strong>{{ $t('message.timer.delivered') }}: </strong>{{ 2 | replaceDotWithComma }}</v-flex>
              <v-flex xs6 sm4 md3 lg3 class="mb-2"><strong>{{ $t('message.timer.notApprovedMsg') }}: </strong>{{ 2 | replaceDotWithComma }}</v-flex>
              <v-flex xs6 sm4 md3 lg3 class="mb-2"><strong>{{ $t('message.timer.approved') }}: </strong>{{ 2 | replaceDotWithComma }}</v-flex>
            </v-row>
          </v-card>
        </template>
      </v-card-text>
      <!-- {{listOfProjects}} -->
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      filterObj: {
        state: 2,
        user_id: 1
      },
      listOfProjects: [],
      loading: false,
      total: 0,
      MODULE: 'projects'
    }
  },
  computed: {
    ...mapGetters(['getUsers', 'getuserDetails'])
  },
  created () {
    this.$store.dispatch('getUsers')
  },
  mounted () {
    this.getListHandler()
  },
  watch: {},
  methods: {
    getListHandler () {
      this.loading = true
      this.$api.execute('get', `${this.MODULE}/filter?state=${this.filterObj.state}&user_id=${this.filterObj.user_id}`)
        .then((response) => {
          let transformData = { date: { list: ['enddate'], from: 'YYYY-MM-DDTHH:mm:ss', to: 'DD.MM.YYYY' }, number: { list: ['cost', 'estimated_hrs', 'received_payment'], format: 'replaceDotWithComma' } }
          let projects = this.$format.formatListModel(response.data, transformData)
          projects.forEach((project, index) => {
            let obj = this.getUsers.find(x => x.so_userid === project.responsibleid) || {}
            projects[index].responsible = obj.name || ''
          })
          this.loading = false
          this.listOfProjects = projects
          this.total = projects.length
        })
    }
  },
  beforeDestroy () {}
}
</script>
